import { render } from "./CompaniesEdit.vue?vue&type=template&id=f5956c4c&scoped=true"
import script from "./CompaniesEdit.vue?vue&type=script&lang=js"
export * from "./CompaniesEdit.vue?vue&type=script&lang=js"

import "./CompaniesEdit.vue?vue&type=style&index=0&id=f5956c4c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5956c4c"]])

export default __exports__